import NavigationBar from "./components/NavigationBar/NavigationBar"
import Hero from "./components/Hero/Hero"
import Skills from "./components/Skills/Skills"
import Education from "./components/Education/Eduction"
import Projects from "./components/Projects/Projects"
import Experience from "./components/Experience/Experience"
import Courses from "./components/Courses/Courses"
import Footer from "./components/Footer/Footer"

export default function App() {
    return (
        <div>
            <NavigationBar />
            <Hero />
            <Skills />
            <Education />
            <Experience />
            <Projects />
            <Courses />
            <Footer />
        </div>
    )
}